import { normalizeFeatureKey, titleToLocaleKey } from 'lib/subscriptionHelpers';
import { EVENT_LABELS } from './helpers';

const MULTIPLIER_KEY = /^(\d+(?:\.\d+)?)xpoints-earned$/;

const formatMultiplier = (value) => (Number.isInteger(value) ? value.toFixed(1) : String(value));

/*
  A feature as the user reads it. The points multiplier's label has a placeholder, and translating
  it without a value printed "{{multiplier}} x Points Earned". The number is in the feature key, so
  the line is built from that, the same way the plan cards do it.
*/
export function featureLabel(t, feature) {
    const multiplier = feature.key?.match(MULTIPLIER_KEY)?.[1];
    if (multiplier) {
        return t('billing.pointsEarned', { multiplier: formatMultiplier(Number(multiplier)) });
    }
    return t(`subscription.features.${normalizeFeatureKey(feature.key)}`, { defaultValue: feature.title });
}

const PLAN_CHANGE_KEYS = {
    upgraded: 'Upgraded',
    downgraded: 'ChangedTo'
};

const planName = (t, title) => t(`subscription.plans.${titleToLocaleKey(title)}`, { defaultValue: title });

/** A plan change names the plan it moved to and the interval, so the row says what happened. */
export function eventLabel(t, evt) {
    const base = t(`billing.event_${evt.eventType}`, { defaultValue: EVENT_LABELS[evt.eventType] || evt.eventType });
    const changeKey = PLAN_CHANGE_KEYS[evt.eventType];
    if (!changeKey || !evt.toPlanTitle) return base;

    const plan = planName(t, evt.toPlanTitle);
    const key = changeKey === 'Upgraded' ? 'eventUpgradedTo' : 'eventChangedTo';
    if (!evt.interval) return t(`billing.${key}`, { plan });

    const interval = t(`billing.interval_${evt.interval}`, { defaultValue: evt.interval });
    return t(`billing.${key}Interval`, { plan, interval });
}
